import { Button, CircularProgress, Divider, Grid, Paper, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import Chart from "react-google-charts";
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useAppSelector } from '../../app/hooks';
import { getProjectDetails, getFanDetails, getFanData, getFetching, getFetchingError, createNewProject, getDrafts, getProjects } from '../../app/reducer/project.reducer';
import { ENCON_LOGO } from '../../assets';
import TorqueCurve from '../charts/TorqueCurve';

export default function Page4() {
  
  const dispatch = useDispatch();
  const history = useHistory();

  const [openErrAlert, setOpenErrAlert] = React.useState<boolean>(false);

  const projectDetails = useAppSelector(getProjectDetails)||{};
  const fanDetails = useAppSelector(getFanDetails);
  const fan = useAppSelector(getFanData);
  const projBusy = useAppSelector(getFetching);
  const fetchingErr = useAppSelector(getFetchingError);
  let projectDate:any;

  if(projectDetails.updatedAt){
    projectDate = new Date(projectDetails.updatedAt+"");
  }else{
    projectDate = new Date();
  }
  let options = { year: 'numeric', month: 'long', day: 'numeric' };
  return (
      <Paper className="datasheet-paper" id="datasheet-page4" style={{width:'100%', padding:'20px'}}>
        <div className="datasheet-row dark-gray">
          <Typography variant="h5" style={{flex:1, textAlign:'center'}}>
            TORQUE CURVES
          </Typography>
        </div>
        <hr/>

        <div className="datasheet-row light-gray">
          <Grid container spacing={3}>
            <Grid item xs={6} lg={6}>
              <div className="data-field">
                <div style={{fontSize:'23px',flex:1, fontWeight:600}}>
                  Project Name:
                </div>
                <div style={{ fontSize:'23px'}}>
                  {projectDetails.project}
                </div>
              </div>
              <div className="data-field">
                <div style={{fontSize:'23px',flex:1, fontWeight:600}}>
                  Customer:
                </div>
                <div style={{ fontSize:'23px'}}>
                  {projectDetails.consultant}
                </div>
              </div>
              <div className="data-field">
                <div style={{fontSize:'23px',flex:1, fontWeight:600}}>
                  Location:
                </div>
                <div style={{ fontSize:'23px'}}>
                  {projectDetails.location}
                </div>
              </div>
            </Grid>
            <Grid item xs={6} lg={6}>
              <div className="data-field">
                <div style={{fontSize:'23px',flex:'1 1 60%', fontWeight:600}}>
                  Date:
                </div>
                <div style={{fontSize:'23px',flex:'1 1 40%',textAlign:'end'}}>
                  {projectDate.toLocaleDateString("en-US", options)}
                </div>
              </div>
              <div className="data-field">
                <div style={{fontSize:'23px',flex:'1 1 60%', fontWeight:600}}>
                  PO/SO No:
                </div>
                <div style={{fontSize:'23px',flex:'1 1 40%',textAlign:'end'}}>
                  {projectDetails.po_number}
                </div>
              </div>
              <div className="data-field">
                <div style={{fontSize:'23px',flex:'1 1 60%', fontWeight:600}}>
                  Project Reference No:
                </div>
                <div style={{fontSize:'23px',flex:'1 1 40%',textAlign:'end'}}>
                  {projectDetails.project_number}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
        <br/>

        <TorqueCurve setIndex={()=>{return;}} fanData={fan} fanDetailsInput={fanDetails} onlyGraph={true}/>
        
        <br/>
        <div className="data-footer">
          <hr/>
          <div className="data-field">
            <div style={{flex:'1 1 60%'}}>
              www.encongroup.co.in
            </div>
            <div style={{flex:'1 1 40%',textAlign:'end'}}>
              Page 4 of 5
            </div>
          </div>
            
        </div>

      </Paper>
  );
}
